import { FileUpload } from "primereact/fileupload";
import { CommonDialog } from "../../common/CommonDialog";
import { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import CmsService from "../../../service/CmsService";
import { ProgressBar } from "primereact/progressbar";
import { useTranslation } from "react-i18next";

export function UploadMediaDialog({visible,onOK,onCancel})
{
    const {t} = useTranslation();
    const [media,setMedia]=useState(null);
    const [mediaType,setMediaType]=useState("VIDEO");
    const [progress,setProgress]=useState(0);

    const mediaTypes=[{label:t('Editor.Audio'),value:'AUDIO'},{label:t('Editor.Video'),value:'VIDEO'},{label:t('Editor.DICOM'),value:'DICOM'}]
    const uploadHandler = (event)=>{
        console.log(event.files);
        setMedia({file:event.files[0]});
    };
    const emptyTemplate=()=>{
        return (
            <div className="flex align-items-cemter col">
                <i className="pi pi-image mt-3 p-5" style={{'fontSize': '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)'}}></i>
                <span style={{'fontSize': '1.2em', color: 'var(--text-color-secondary)'}} className="my-5">{t('Editor.Drag_and_drop_media_file_here')}</span>
            </div>
        )
    };
    const chooseOptions = {label: t('Editor.Choose'), icon: 'pi pi-fw pi-plus'};
    const uploadOptions = {};
    const cancelOptions = {};
    const progressHandle=(e)=>{
        setProgress(e.loaded*100.0/e.total);
        console.log("uploadProgress:"+e.loaded+"/"+e.total);
    }

    const _onOK=(e)=>{
        if (!media) 
			return;
        CmsService.uploadMedia(null,mediaType,media,progressHandle).then((ret)=>{
            ret.mediaType = mediaType;
            onOK(ret);
        }).catch((err)=>{
            console.log("err:"+err);
            //showError(err);
        });

    };
    const _onCancel=(e)=>{
        onCancel();
    };
    return(
        <>
            <CommonDialog header={t('Editor.Upload_Media')} onOK={_onOK} onCancel={_onCancel} visible={visible}>
                <div className="fluid formgrid grid">
                    <div className="field col-12 mb-2">
                        <label htmlFor="mediaType">{t('Editor.Media_Type')}</label>
                        <Dropdown id="mediaType" className="w-full" value={mediaType} 
                            options={mediaTypes} onChange={(val)=>setMediaType(val.value)}
                            optionLabel="label" optionValue="value"></Dropdown>
                    </div>
                    <div className="field col-12 mb-2">
                        <ProgressBar value={progress}/>
                    </div>
                    <div className="field col-12">
                        <FileUpload name="media" mode="advanced" auto
                        multiple={false} emptyTemplate={emptyTemplate} chooseOptions={chooseOptions} 
                        uploadOptions={uploadOptions} cancelOptions={cancelOptions} customUpload uploadHandler={uploadHandler}/> 
                    </div>
                </div>
            </CommonDialog>                 
        </>
    );
}